<template>
	<select
		name="location"
		class="mt-1 block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary-light focus:border-primary rounded-md"
		:class="{
            'border-red-500 bg-red-100': hasError,
        }"
        @change="$emit('update:modelValue', $event.target.value)"
        :value="modelValue || ''"
        @update:value="modelValue = $event"
	>
		<option value="" v-if="allowEmpty">{{ __('admin::forms.select') }}</option>
        <option v-for="(v, k) in options" :key="k" :value="k">{{ v }}</option>
	</select>
</template>

<script>
	export default {
		props: {
			modelValue: {
				type: [String, Number],
				default: '',
			},
			options: {
				type: Object,
				default: () => {},
			},
			allowEmpty: {
                type: Boolean,
                default: false,
            },
			hasError: {
                type: Boolean,
                default: false,
            },
		},

		emits: ['update:modelValue'],

        methods: {
            focus() {
                this.$refs.input.focus()
            }
        },
	}
</script>
